module.exports = __webpack_public_path__ + "img/ewm.494f9d2b.jpg";